import RecommendedStepsCard from './RecommendedStepsCard';
import ProductResourcesCard from './ProductResourcesCard';
import GetStartedCard from './GetStartedCard';

export default [ProductResourcesCard, RecommendedStepsCard, GetStartedCard];
